import React from 'react';
import { useScrollFadeIn } from '../hooks/useScrollFadeIn';

const FadeInSection = ({ children, delay = 0 }) => {
  const [ref, isVisible] = useScrollFadeIn(0.1);

  return (
    <div
      ref={ref}
      className={`transition-all duration-1000 ease-out ${
        isVisible 
          ? 'opacity-100 translate-y-0' 
          : 'opacity-0 translate-y-8'
      }`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
};

export default FadeInSection;
